import type { ComponentProps } from "react";
import type {
  WrappedFieldInputProps,
  WrappedFieldMetaProps
} from "redux-form";

import UpFieldWithErrorState from "../UpFieldWithErrorState";
import UpInput from "../up-input";

type FieldShellProps = Pick<
  ComponentProps<typeof UpFieldWithErrorState>,
  "label" | "margin" | "width" | "infoText" | "flex" | "required"
>;

type InputPresentationProps = Partial<
  Pick<ComponentProps<typeof UpInput>, "type" | "placeholder">
>;

type ReduxInputProps = Pick<WrappedFieldInputProps, "name"> &
  Partial<Omit<WrappedFieldInputProps, "name" | "value">> &
  ComponentProps<typeof UpInput>;

type ReduxMetaProps = Omit<
  Pick<WrappedFieldMetaProps, "touched" | "error">,
  "error"
> & {
  error?: unknown;
};

export type UpReduxFormInputProps = Omit<FieldShellProps, "label"> &
  InputPresentationProps & {
    input: ReduxInputProps;
    meta: ReduxMetaProps;
    label: NonNullable<FieldShellProps["label"]>;
  };

const UpReduxFormInput = ({
  input,
  meta,
  label,
  margin = "0 0 20px 0",
  width = "100%",
  infoText,
  flex = "1 1",
  required,
  type = "string",
  placeholder
}: UpReduxFormInputProps) => {
  const hasError = meta.touched && meta.error !== undefined;
  const inputClassName = meta.touched && Boolean(meta.error) ? "error" : undefined;

  return (
    <UpFieldWithErrorState
      error={hasError}
      label={label}
      margin={margin}
      width={width}
      infoText={infoText}
      flex={flex}
      required={required}
    >
      <UpInput
        {...input}
        type={type}
        placeholder={placeholder}
        width={width}
        className={inputClassName}
        autoComplete="off"
      />
    </UpFieldWithErrorState>
  );
};

export default UpReduxFormInput;
